<div class="container">
    <h2 mat-dialog-title>Edit Credit Plan</h2>

    <mat-form [formGroup]="formGroup">
        <mat-form-field appearance="outline" *ngFor="let field of this.form">
            <div *ngIf="field.type !== 'slide' && field.type !== 'textarea' && field.editable">
                <mat-label>{{ field.title }}</mat-label>
                <span matTextPrefix>{{ field.prefix }}&nbsp;</span>

                <input matInput [formControlName]="field.name" [type]="field.type" [placeholder]="field.placeholder" [readonly]="!field.editable" [hidden]="!field.editable"
                    step="any" *ngIf="field.format == undefined" [value]="field.control.value">
                <input matInput [formControlName]="field.name" [type]="field.type" [placeholder]="field.placeholder" [readonly]="!field.editable" [hidden]="!field.editable"
                    step="any" *ngIf="field.format == 'phone'" [value]="field.control.value | phone">
            </div>

            <div *ngIf="field.type === 'textarea' && field.editable">
                <mat-label>{{ field.title }}</mat-label>
                <span matTextPrefix>{{ field.prefix }}&nbsp;</span>

                <textarea matInput [formControlName]="field.name" [placeholder]="field.placeholder" [readonly]="!field.editable" [hidden]="!field.editable"
                    rows="4" cols="50">{{field.control.value}}</textarea>
            </div>

            <div *ngIf="field.type === 'slide' && field.editable">
                <mat-slide-toggle [formControlName]="field.name">{{field.control.value ? 'Active' : 'Inactive'}}</mat-slide-toggle>
                <input matInput hidden disabled>
            </div>

            <div *ngIf="!field.editable">
                <mat-label>{{ field.title }}</mat-label>
                <span matTextPrefix>{{ field.prefix }}&nbsp;</span>

                <input matInput hidden disabled [value]="field.control.value">
            </div>

            <mat-error *ngIf="field.control.invalid && (field.control.dirty|| field.control.touched)">
                <span *ngIf="field.control.errors?.['required']">{{ field.title }} is required</span>
                <span *ngIf="field.control.errors?.['pattern']">{{ field.title }} is invalid</span>
                <span *ngIf="field.control.errors?.['email']">{{ field.title }} is an invalid email</span>
                <span *ngIf="field.control.errors?.['maxlength']">{{ field.title }} has invalid length</span>
                <span *ngIf="field.control.errors?.['minlength']">{{ field.title }} has invalid length</span>
            </mat-error>
        </mat-form-field>
    </mat-form>

    <div class="update-notes">
        <div class="label">Update Notes (Optional)</div>
        <textarea matInput type="textarea" [(ngModel)]="updateNotes" placeholder="Enter notes for this update"></textarea>
    </div>

    <div class="form-actions" mat-dialog-actions>
        <button mat-flat-button color="accent" [disabled]="this.formGroup.invalid || !this.formGroup.dirty" (click)="save()">Save Changes</button>
        <button mat-flat-button class="cancel" (click)="cancel()">Cancel</button>
    </div>
    
</div>
